var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.2479C2.36618 6.30929 6.30929 2.36618 11.2479 2V3.97778C11.2479 4.39314 11.5846 4.72986 12 4.72986C12.4154 4.72986 12.7521 4.39314 12.7521 3.97778V2C17.6907 2.36618 21.6338 6.30929 22 11.2479H20.0222C19.6069 11.2479 19.2701 11.5846 19.2701 12C19.2701 12.4154 19.6069 12.7521 20.0222 12.7521H22C21.6338 17.6907 17.6907 21.6338 12.7521 22V20.0222C12.7521 19.6069 12.4154 19.2701 12 19.2701C11.5846 19.2701 11.2479 19.6069 11.2479 20.0222V22C6.30929 21.6338 2.36618 17.6907 2 12.7521H3.97778C4.39314 12.7521 4.72986 12.4154 4.72986 12C4.72986 11.5846 4.39314 11.2479 3.97778 11.2479H2ZM12.75 9C12.75 8.58579 12.4142 8.25 12 8.25C11.5858 8.25 11.25 8.58579 11.25 9V11.25H9C8.58579 11.25 8.25 11.5858 8.25 12C8.25 12.4142 8.58579 12.75 9 12.75H11.25V15C11.25 15.4142 11.5858 15.75 12 15.75C12.4142 15.75 12.75 15.4142 12.75 15V12.75H15C15.4142 12.75 15.75 12.4142 15.75 12C15.75 11.5858 15.4142 11.25 15 11.25H12.75V9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.21f45fd4a3834c286b847fe806fef0e8.svg";
export { ForwardRef as ReactComponent };